<template>
  <div v-if="!updating" class="section-row">
    <div class="vue-form">
      <div class="pickpost-form">
        <div class="vue-form-row has-multiple-elements">
          <vue-input @blur="setPickPostFieldValue({ fieldId: 'pickPostValue', value: $event.target.value })"
            :element="pickPost" />
        </div>
      </div>
    </div>
  </div>
</template>
<script src="./pick-post.js"/>